module.exports = __webpack_public_path__ + "static/staw-mostek-2005861c4cb0ed0c8439eab49e298c12.jpg";